import _ from 'lodash';
import moment from 'moment';
import React, {PropTypes} from 'react';

class MemberResourceRow extends React.Component {
  render() {
    const {
      user,
      firstDay,
      lastDay
    } = this.props;

    return (
      <div className="row">
        {_.times(lastDay.diff(firstDay, 'days') + 1, (day) => {
          let aDay = moment(firstDay).add(day, 'days');
          const h = 8 - user.dailyHours[`d${aDay.format('MM')}${aDay.format('DD')}`];
          return <div className={`col resource-col-${h < 0 ? 0 : h}`} key={day}>{h}</div>
        })}
      </div>
    )
  }
}

MemberResourceRow.propTypes = {
  user: PropTypes.object.isRequired,
  firstDay: PropTypes.object.isRequired,
  lastDay: PropTypes.object.isRequired
};

export default MemberResourceRow;



/** WEBPACK FOOTER **
 ** ./src/components/MemberResourceRow.js
 **/